import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=35e2d3f9&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e2d3f9')) {
      api.createRecord('35e2d3f9', component.options)
    } else {
      api.reload('35e2d3f9', component.options)
    }
    module.hot.accept("./Textarea.vue?vue&type=template&id=35e2d3f9&", function () {
      api.rerender('35e2d3f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Textarea.vue"
export default component.exports